import { MultilineTextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../../components/ApplicationQuestionReviewItem';
import { usePropertyDevelopmentOther } from '../../../../../../queries/PropertyFields';

interface PropertyDevelopmentOtherProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const PropertyDevelopmentOther: React.FC<PropertyDevelopmentOtherProps> = ({
    propertyGuid,
    required = false,
    isReview = false,
}) => {
    const label = 'Please provide a brief description';

    const [propertyDevelopmentOther, set_propertyDevelopmentOther] = usePropertyDevelopmentOther(propertyGuid);

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={propertyDevelopmentOther}
                />
            ) : (
                <MultilineTextBox
                    id='propertyDevelopmentOther'
                    value={propertyDevelopmentOther}
                    onChange={set_propertyDevelopmentOther}
                    label={label}
                    required={required}
                />
            )}
        </>
    );
};
